import { render } from "./orders-list-page.vue?vue&type=template&id=54d6f7aa&scoped=true"
import script from "./orders-list-page.vue?vue&type=script&lang=js"
export * from "./orders-list-page.vue?vue&type=script&lang=js"

import "./orders-list-page.vue?vue&type=style&index=0&id=54d6f7aa&lang=css&scoped=true"

import exportComponent from "../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54d6f7aa"]])

export default __exports__